import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IBranchMastDropdown, ICompanyMastDropdown, IDesignationMastDropdown } from "../../../models/IDropdown";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { JVDate } from "../../../shared/JVDate";
import { MultiSelect } from "primereact/multiselect";

export interface IFilter {
  fromDate: Date | null;
  toDate: Date | null;
  vendor_Company: {
    vendor_Company_ID: number;
    vendor_Company_Name: string;
  } | null;
  vendor_Company_Name?: string | null;
  contact_Person_Name?: string | null;
  contact_Person_EmailID?: string | null;
  department?: number | null;
  designationId?: number | null;
  added_By?: number[] | null;
}

interface IProps {
  filters: IFilter;
  setFilters: (filters: IFilter) => void;
  loading: boolean;
}

const schema = yup.object({
  contact_Person_EmailID: yup.string().nullable(),
  vendor_Company: yup
    .object()
    .shape({
      vendor_Company_ID: yup.number().min(1, "Client Company Name is required*").required("Client Company Name is required*"),
      vendor_Company_Name: yup.string().required(),
      website_URL: yup.string(),
    })
    .nullable(),
  contact_Person_Name: yup.string().nullable(),
  designation: yup.number().nullable(),
  cell_No: yup.string().nullable(),
  department: yup.string().nullable(),
  added_By: yup.number().nullable(),
});

export const Filter = (props: IProps) => {
  const [clients, setClients] = useState<{ id: number; client_Name: string }[]>([]);
  const [designations, setDesignations] = useState<IDesignationMastDropdown[]>([]);
  const [preSales, setPreSales] = useState<{ login_ID?: number; user_Name?: string }[]>([]);
  const [users, setUsers] = useState<number[]>([]);
  const [deparment, setDeparment] = useState<any[]>([]);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFilter>({
    resolver: yupResolver(schema),
    defaultValues: props.filters,
    shouldFocusError: false,
  });

  const loadDesignations = async () => {
    const response = await Fetch("Dropdown/designation", "GET", null, null, null);
    if (response) {
      const data: Array<IDesignationMastDropdown> = await response.json();
      const emptyData = {
        designationId: 0,
        designation_Name: "-- SELECT --",
      };
      data.unshift(emptyData);
      setDesignations(data);
    }
  };

  const loadDepartment = async () => {
    const response = await Fetch("RFP_POC_Department_Mast/GetActiveDepartment", "GET", null, null, null);
    if (response?.ok) {
      const data: Array<any[]> = await response.json();
      setDeparment(data);
    }
  };

  useEffect(() => {
    loadPreSales();
    loadDesignations();
    loadDepartment();
  }, []);

  // useEffect(() => {
  //     const subscription = watch((value, { name, type }) => {
  //         if (name === "company") {
  //             if (value.company != 0 && value.company != null) {
  //                 loadBranches(value.company);
  //             } else {
  //                 loadBranches();
  //             }
  //         }
  //     });

  //     return () => subscription.unsubscribe();
  // }, [watch]);

  const loadClients = async (search?: string) => {
    const response = await Fetch("Tender_POC_Mast/getClientsByCategory", "GET", null, search ? `filter=${search}` : null, null);
    if (response?.ok) {
      const data = await response.json();
      setClients(data);
    }
  };

  const loadPreSales = async () => {
    const response = await Fetch("Tender_POC_Mast/getPreSales", "GET", null, null, null);
    if (response?.ok) {
      const data = await response.json();
      setPreSales(data);
    }
  };

  const completeMethod = (e: { query: string }) => {
    loadClients(e?.query);
  };

  const onSubmit = (data: IFilter) => {
    if (users.length > 0) data.added_By = users;
    props.setFilters(data);
  };

  const clearForm = () => {
    reset(EmptyFilter);
    setUsers([]);
    props.setFilters(EmptyFilter);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVDate column={6} label="From Date" control={control} name="fromDate" />
      <JVDate column={6} label="To Date" control={control} name="toDate" />
      <JVDropdownInput column={6} completeMethod={completeMethod} label="Client Name" control={control} name="vendor_Company" error={errors.vendor_Company?.message} options={clients} optionLabel="vendor_Company_Name" placeholder="Search Client Company" />
      <JVInput column={6} label="Contact Name" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
      <JVInput column={6} label="Contact Email" control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
      <JVDropdown column={6} label="Designation" control={control} name="designationId" error={errors.designationId?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />
      <JVDropdown column={6} label="Department" control={control} name="department" error={errors.department?.message} options={deparment} optionLabel="department" optionValue="id" placeholder="Select Deparment" />
      {/* <JVDropdown column={6} label="Added By" filter control={control} name="added_By" error={errors.added_By?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" /> */}
      <div className="field col-2 md:col-2">
        <p>Added By</p>
        <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={users} onChange={(e) => setUsers(e.value)} options={preSales} optionValue="login_ID" optionLabel="user_Name" display="chip" filter placeholder="Select Users" />
      </div>
      <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
        <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading} />
        <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={clearForm} type="button" />
      </div>
    </form>
  );
};
